<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template class="pa-5">
      <div ref="canvasWrapper" class="d-none" />

      <!-- بخش راهنما و آیکون‌ها -->
      <v-row class="my-8 custom-icons-row" justify="center" align="center" no-gutters>
        
        <!-- دکمه راهنمای فرمت‌ها -->
        <div class="guide-btn-wrapper mr-2" @click="showGuideDialog = true">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="info" v-bind="attrs" v-on="on" class="guide-btn elevation-2">
                <v-icon>mdi-information-outline</v-icon>
              </v-btn>
            </template>
            <span>راهنمای انتخاب فرمت مناسب</span>
          </v-tooltip>
        </div>

        <!-- آیکون‌های دانلود سریع با Tooltip -->
        <v-tooltip 
          top 
          v-for="item in multipleType" 
          :key="item.value"
          color="dark"
        >
          <template v-slot:activator="{ on, attrs }">
            <div 
              class="custom-file-icon mx-1" 
              v-bind="attrs" 
              v-on="on"
              @click="quickDownload(item.value)"
            >
              <img 
                :src="`/media/download/${item.value}.webp`" 
                :alt="`دانلود ${item.text}`"
                class="file-icon-img"
                @error="onImgError"
              />
            </div>
          </template>
          <div class="text-center">
            <strong>{{ item.text }}</strong>
            <div class="caption mt-1">{{ item.desc }}</div>
          </div>
        </v-tooltip>
        <div 
          class="settings-btn-wrapper ml-2" 
          @click="showAdvanced = !showAdvanced" 
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
               <div 
                               v-bind="attrs" 
                v-on="on"
          class="settings-btn-wrapper" 
          :title="showAdvanced ? 'بستن تنظیمات' : 'تنظیمات بیشتر'"
        >
          <div class="settings-icon-box" :class="{'active-settings': showAdvanced}">
            <v-icon size="30" :color="showAdvanced ? 'white' : '#757575'">
              {{ showAdvanced ? 'mdi-close' : 'mdi-tune' }}
            </v-icon>
          </div>
          </div>
            </template>
            <span>{{ showAdvanced ? 'بستن تنظیمات' : 'تنظیمات پیشرفته سایز و کیفیت' }}</span>
          </v-tooltip>
        </div>

      </v-row>

      <!-- دراپ‌داون‌های تنظیمات حرفه‌ای -->
      <v-expand-transition>
        <div v-show="showAdvanced" class="advanced-settings-box pa-5 mb-4 rounded-lg">
          
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" :md="(computedFormat === 'dxf' || computedFormat === 'eps') ? '4' : '6'">
              <v-autocomplete
                v-model="qrType"
                :items="types"
                append-icon="mdi-image-outline"
                dense
                outlined
                class="contentinfo"
                :label="$t('format')"
                hide-details
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                    <v-list-item-subtitle class="text-caption text-grey" v-if="item.desc" v-text="item.desc"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col v-if="qrType !== 'selectable'" class="pa-2" cols="12" :md="(computedFormat === 'dxf' || computedFormat === 'eps') ? '4' : '6'">
              <v-autocomplete
                v-model="qrSize"
                :items="sizes"
                append-icon="mdi-format-list-bulleted-type"
                dense
                outlined
                class="contentinfo"
                :label="$t('output_size')"
                hide-details
              />
            </v-col>

            <v-col v-else class="pa-2" cols="12" :md="(computedFormat === 'dxf' || computedFormat === 'eps') ? '4' : '6'">
              <v-autocomplete
                v-model="extension"
                :items="multipleType"
                append-icon="mdi-export"
                dense
                outlined
                class="contentinfo"
                :label="$t('file_type')"
                hide-details
              />
            </v-col>

            <v-col v-if="computedFormat === 'dxf' || computedFormat === 'eps'" class="pa-2" cols="12" :md="'4'">
              <v-autocomplete 
                v-model="pixel_c"
                :items="CountPixels"
                append-icon="mdi-dots-grid"
                dense
                outlined
                class="contentinfo"
                label="تراکم (کیفیت)"
                hide-details
              ></v-autocomplete>
            </v-col>

            <v-col class="pa-2 mt-2" cols="12">
              <v-btn
                :loading="loading"
                class="btn-download rounded-lg ma-0 w-100"
                block
                large
                @click="downloadFile"
              >
                <v-icon class="me-2">mdi-cloud-download</v-icon>دانلود
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>

      <!-- مدال راهنمای فرمت‌ها -->
           <custom-popup
              v-model="showGuideDialog"
              :cons="{title:'راهنمای انتخاب فرمت مناسب',icon:'information-outline'}"
              hide-confirm
              max-width="700"
              scrollable
            >
        <v-card class="rounded-lg pa-4">
          <v-card-text class="pa-0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr class="bg-grey-lighten-4">
                    <th class="text-right font-bold">فرمت</th>
                    <th class="text-right">بهترین کاربرد</th>
                    <th class="text-right">نکته مهم</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in formatsGuide" :key="item.name">
                    <td class="font-weight-bold text-primary">{{ item.name }}</td>
                    <td>{{ item.usage }}</td>
                    <td class="text-caption text-grey-darken-2">{{ item.note }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="pa-4 bg-grey-lighten-5 justify-end">
            <v-btn class="btn-show rounded-lg" @click="showGuideDialog = false">متوجه شدم</v-btn>
          </v-card-actions>
        </v-card>
           </custom-popup>

      <v-overlay :value="loading" z-index="999">
        <v-progress-circular indeterminate size="64" color="white" width="6"></v-progress-circular>
      </v-overlay>

    </template>
  </help-info-wrapper>
</template>

<script>
import QRCodeStyling from "qr-code-styling";
import { writePsd } from "ag-psd";
import Drawing from "dxf-writer";

export default {
  name: "downloadFileWithApi",
  props: {
    visitName: { type: String, default: "qr" },
    address: { type: String, default: "qrland.in" },
    isQrlink: { type: Boolean, default: false },
    qr_id: { type: String, default: "" },
    svg: { type: String, default: null },
    preloadedInfo: { type: Object, default: () => null }
  },
  data() {
    return {
      showAdvanced: false,
      showGuideDialog: false,
      pixel_c: "1", 
      CountPixels: [
        { text: "۱۰۰٪ (بیشترین تراکم - بالاترین کیفیت)", value: '1' },
        { text: "۹۰٪", value: '2' },
        { text: "۸۰٪", value: '3' },
        { text: "۷۰٪", value: '4' },
        { text: "۶۰٪", value: '5' },
        { text: "۵۰٪ (تراکم متوسط)", value: '6' },
        { text: "۴۰٪", value: '7' },
        { text: "۳۰٪", value: '8' },
        { text: "۲۰٪", value: '9' },
        { text: "۱۰٪ (کمترین تراکم - سبک‌ترین فایل)", value: '10' },
      ],
      info: {},
      helpData: [],
      serviceName: "Qrland",
      componentName: "downloadFile",
      
      // آپدیت شده: اضافه کردن توضیحات برای Tooltip و Dropdown
      types: [
        { text: "SVG", value: "svg", desc: "بدون افت کیفیت، عالی برای چاپ بنر و کارت ویزیت" },
        { text: "PNG", value: "png", desc: "کیفیت بالا با پس‌زمینه شفاف، مناسب سایت و سوشال مدیا" },
        { text: "JPEG", value: "jpeg", desc: "حجم مناسب، سازگار با تمام دستگاه‌ها (بدون پس‌زمینه شفاف)" },
        { text: "WEBP", value: "webp", desc: "حجم بسیار کم، مناسب برای لود سریع در وب‌سایت‌ها" },
        { text: "PSD", value: "psd", desc: "فایل لایه‌باز برای استفاده مستقیم در نرم‌افزار فتوشاپ" },
        { text: "DXF", value: "dxf", desc: "فرمت برداری برای دستگاه‌های برش لیزر و حکاکی CNC" },
        { text: "EPS", value: "eps", desc: "فرمت برداری استاندارد برای چاپخانه‌ها و ایلاستریتور" },
        { text: "اندازه سفارشی", value: "selectable", desc: "انتخاب دستی ابعاد خروجی" },
      ],
      
      // دیتای مربوط به مدال راهنما
      formatsGuide: [
        { name: "SVG", usage: "چاپ کارت ویزیت، بنر، تراکت و نمایش در سایت", note: "بهترین انتخاب عمومی. بدون افت کیفیت بزرگ می‌شود و پس‌زمینه شفاف دارد." },
        { name: "PNG", usage: "سایت، شبکه‌های اجتماعی، فایل‌های اداری (Word)", note: "شفافیت دارد و لبه‌های QR واضح است. با بزرگ‌کردن بیش از حد پیکسلی می‌شود." },
        { name: "JPEG", usage: "سامانه‌هایی که فقط JPG قبول می‌کنند", note: "شفافیت ندارد. فشرده‌سازی ممکن است دور خانه‌های QR هاله ایجاد کند." },
        { name: "WEBP", usage: "فروشگاه‌های اینترنتی و وب‌سایت‌ها", note: "حجم بسیار کم و پشتیبانی از شفافیت. برای چاپ مناسب نیست." },
        { name: "PSD", usage: "تحویل به طراح گرافیک", note: "جهت استفاده مستقیم داخل پروژه‌های فتوشاپ." },
        { name: "DXF", usage: "حکاکی CNC، برش لیزر و اتوکد", note: "پیکسل‌ها را به مختصات هندسی (مستطیل) تبدیل می‌کند." },
        { name: "EPS", usage: "تحویل به چاپخانه‌ها", note: "قالب رایج برداری در فرایندهای چاپ قدیمی و صنعتی." },
      ],

      qrSize: "default",
      qrType: "svg",
      extension: "svg",
      loading: false,
    };
  },
  computed: {
    sizes() {
      return [
        { text: this.$t("default") + " (کیفیت اصلی)", value: "default" },
        { text: "100x100 px", value: "100" },
        { text: "200x200 px", value: "200" },
        { text: "300x300 px", value: "300" },
        { text: "400x400 px", value: "400" },
        { text: "500x500 px", value: "500" },
        { text: "600x600 px", value: "600" },
        { text: "700x700 px", value: "700" },
        { text: "800x800 px", value: "800" },
        { text: "900x900 px", value: "900" },
        { text: "1000x1000 px", value: "1000" },
      ];
    },
    getVisitName() {
      let str = this.qrSize !== "default" ? `-${this.qrSize}` : "";
      return this.visitName.replace(/\s+/g, "_") + str;
    },
    multipleType() {
      return this.types.filter((item) => item.value !== "selectable");
    },
    computedFormat() {
      return this.qrType === "selectable" ? this.extension : this.qrType;
    },
    fetchEndpoint() {
      if (this.preloadedInfo) return null;
      if (this.isQrlink) return this.qr_id ? `/v1/testQr/find1/${this.qr_id}` : null;
      return this.address ? `/v1/testQr/find/${this.address}` : null;
    }
  },
  watch: {
    fetchEndpoint: {
      immediate: true,
      handler(newEndpoint) {
        if (newEndpoint) {
          this.fetchData(newEndpoint);
        }
      }
    },
    preloadedInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.info = newVal;
      }
    }
  },
  methods: {
    fetchData(endpoint) {
      this.loading = true;
      this.$api.get(endpoint).then(({ data }) => {
        this.info = data.data;
      }).catch((error) => console.error("Error fetching QR data:", error))
        .finally(() => (this.loading = false));
    },    
    onImgError(e) { e.target.style.display = 'none'; },
    async quickDownload(format) {
      this.qrType = format;
      this.extension = format;
      this.qrSize = "default";
      this.pixel_c = "1";
      await this.downloadFile();
    },
    downloadBlob(blob, filename) {
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl; link.download = filename;
      document.body.appendChild(link); link.click();
      document.body.removeChild(link); window.URL.revokeObjectURL(downloadUrl);
    },
    async saveAsPsd(canvas, fileName) {
      const psd = { width: canvas.width, height: canvas.height, children: [{ name: "QR Code", canvas: canvas }] };
      const buffer = writePsd(psd);
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      this.downloadBlob(blob, `${fileName}.psd`);
    },
    async saveAsDxf(canvas, size, fileName) {
      const d = new Drawing(); d.setUnits("Pixels");
      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, size, size); const data = imgData.data;
      const step = parseInt(this.pixel_c) || 1;
      for (let y = 0; y < size; y += step) {
        for (let x = 0; x < size; x += step) {
          const index = (y * size + x) * 4;
          const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3];
          if (a > 128 && (r + g + b) / 3 < 128) d.drawRect(x, -y, x + step, -(y + step));
        }
      }
      const dxfString = d.toDxfString();
      const blob = new Blob([dxfString], { type: "application/dxf" });
      this.downloadBlob(blob, `${fileName}.dxf`);
    },
    async saveAsEps(canvas, size, fileName) {
      const ctx = canvas.getContext("2d");
      const imgData = ctx.getImageData(0, 0, size, size); const data = imgData.data;
      const step = parseInt(this.pixel_c) || 1;
      let epsString = "%!PS-Adobe-3.0 EPSF-3.0\n";
      epsString += `%%BoundingBox: 0 0 ${size} ${size}\n%%Creator: Qrland\n%%EndComments\n`;
      epsString += `/box { newpath moveto ${step} 0 rlineto 0 ${step} rlineto -${step} 0 rlineto closepath fill } bind def\n`;
      let lastColor = null;
      for (let y = 0; y < size; y += step) {
        for (let x = 0; x < size; x += step) {
          const index = (y * size + x) * 4;
          const r = data[index], g = data[index + 1], b = data[index + 2], a = data[index + 3];
          if (a > 128 && (r < 250 || g < 250 || b < 250)) {
            const psR = (r / 255).toFixed(3), psG = (g / 255).toFixed(3), psB = (b / 255).toFixed(3);
            const currentColor = `${psR} ${psG} ${psB}`;
            if (currentColor !== lastColor) { epsString += `${currentColor} setrgbcolor\n`; lastColor = currentColor; }
            const epsY = size - y - step;
            epsString += `${x} ${epsY} box\n`;
          }
        }
      }
      epsString += "%%EOF\n";
      const blob = new Blob([epsString], { type: "application/postscript" });
      this.downloadBlob(blob, `${fileName}.eps`);
    },
    async downloadSvgFromUrl() {
      const svgUrl = (this.svg ||this.info.img_url || this.info.image || this.info.data?.data?.image);
      const fileName = this.getVisitName || "qr";
      const extension = this.computedFormat || "svg";
      const size = this.qrSize !== "default" ? Number(this.qrSize) : 600; // پیش‌فرض سایز را بهتر است برای دانلود روی 600 بگذاریم
      if (!svgUrl) throw new Error("آدرس SVG نامعتبر یا وجود ندارد");
      try {
        let text = "";
        if (svgUrl.startsWith("data:image/svg+xml;base64,")) {
          const base64Data = svgUrl.replace("data:image/svg+xml;base64,", "");
          text = decodeURIComponent(escape(window.atob(base64Data)));
        } else if (this.svg && this.svg.includes('http')) {
          const cleanUrl = this.svg.replace('data:image/svg+xml;base64,', '');
          const response = await fetch(cleanUrl);
          text = await response.text();
        } else {
          const response = await fetch(`${this.$qrApi}/convert?file_path=${this.info.image}`);
          text = await response.text();
        }

        if (extension === "svg") {
          text = text.replace(/<svg([^>]*)width="[^"]*"([^>]*)>/, `<svg$1$2>`);
          text = text.replace(/<svg([^>]*)height="[^"]*"([^>]*)>/, `<svg$1$2>`);
          text = text.replace(/<svg([^>]*)>/, `<svg$1 width="${size}" height="${size}">`);
          const svgBlob = new Blob([text], { type: "image/svg+xml" });
          this.downloadBlob(svgBlob, `${fileName}.svg`);
        } else {
          const svgBlob = new Blob([text], { type: "image/svg+xml" });
          const url = window.URL.createObjectURL(svgBlob);
          const img = new Image();
          img.crossOrigin = "anonymous";
          await new Promise((resolve, reject) => {
            img.onload = resolve; img.onerror = () => reject(new Error("بارگذاری تصویر ناموفق بود")); img.src = url;
          });
          const canvas = document.createElement("canvas");
          canvas.width = size; canvas.height = size;
          const ctx = canvas.getContext("2d"); ctx.drawImage(img, 0, 0, size, size);

          if (extension === "psd") await this.saveAsPsd(canvas, fileName);
          else if (extension === "dxf") await this.saveAsDxf(canvas, size, fileName);
          else if (extension === "eps") await this.saveAsEps(canvas, size, fileName);
          else canvas.toBlob((blob) => this.downloadBlob(blob, `${fileName}.${extension}`), `image/${extension}`, 1.0);
          
          window.URL.revokeObjectURL(url);
          this.$toast.success(this.$t("qr_downloaded_successfully"));
        }
      } catch (error) {
        await this.generateLocalQrFallback();
      }
    },
    async generateLocalQrFallback() {
      const fileName = this.getVisitName || "qr";
      const extension = this.computedFormat || "png";
      const size = this.qrSize !== "default" ? Number(this.qrSize) : 600;
      const data = this.info?.link || this.info?.address || this.address || "https://qrland.in";

      try {
        let qrConfig = this.info?.data?.data?.qr_config || { dotsOptions: { type: "rounded", color: "#4c4c4c" }, backgroundOptions: { color: "#FFFFFFFF" } };
        const usedExtension = (extension === "psd" || extension === "dxf" || extension === "eps") ? "png" : extension;
        qrConfig = { ...qrConfig, width: size, height: size, type: usedExtension, data: data };

        const qrCode = new QRCodeStyling(qrConfig);
        const canvasWrapper = this.$refs.canvasWrapper; canvasWrapper.innerHTML = "";
        qrCode.append(canvasWrapper);
        await this.$nextTick();

        if (extension === "psd" || extension === "dxf" || extension === "eps") {
          const rawData = await qrCode.getRawData("png");
          const img = new Image(); const url = window.URL.createObjectURL(rawData);
          img.onload = async () => {
            const canvas = document.createElement("canvas");
            canvas.width = size; canvas.height = size;
            const ctx = canvas.getContext("2d"); ctx.drawImage(img, 0, 0, size, size);
            
            if (extension === "psd") await this.saveAsPsd(canvas, fileName);
            else if (extension === "dxf") await this.saveAsDxf(canvas, size, fileName);
            else if (extension === "eps") await this.saveAsEps(canvas, size, fileName);
            window.URL.revokeObjectURL(url);
            this.$toast.success(this.$t("qr_downloaded_successfully"));
          };
          img.src = url;
        } else {
          await qrCode.download({ name: fileName, extension: extension });
          this.$toast.success(this.$t("qr_downloaded_successfully"));
        }
      } catch (error) {
        this.$toast.error("خطا در تولید فایل");
      }
    },
    async downloadFile() {
      this.loading = true;
      try {
        if (this.svg!=="" && (this.svg || this.info?.data?.data?.tab_design === 1 || this.info.img_url)) {
          await this.downloadSvgFromUrl();
        } else {
          await this.generateLocalQrFallback();
        }
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.d-none { display: none; }

/* چیدمان آیکون‌ها */
.custom-icons-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 16px;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

/* ------------------- استایل آیکون‌های دانلود ------------------- */
.custom-file-icon {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #f8f9fa;
  border-radius: 14px;
  border: 1px solid #edf2f7;
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.custom-file-icon:hover {
  transform: translateY(-5px) scale(1.05);
  background: #ffffff;
  border-color: var(--v-primary-base, #1976D2);
  box-shadow: 0 8px 15px rgba(25, 118, 210, 0.15);
}

.file-icon-img {
  width: 90%;
  height: auto;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
}

/* ------------------- دکمه راهنما و تنظیمات ------------------- */
.guide-btn {
  background-color: #f0f7ff !important;
}
.guide-btn:hover {
  background-color: #e0f0ff !important;
}

.settings-btn-wrapper {
  width: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.settings-icon-box {
  width: 52px;
  height: 52px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
}

.settings-icon-box:hover {
  border-color: var(--v-primary-base, #1976D2);
  background-color: #e3f2fd;
}

.settings-icon-box.active-settings {
  background-color: var(--v-primary-base, #1976D2);
  border-color: var(--v-primary-base, #1976D2);
  transform: rotate(90deg);
}

/* ------------------- جعبه تنظیمات پیشرفته ------------------- */
.advanced-settings-box {
  background-color: #ffffff;
  border: 1px solid #edf2f7;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  position: relative;
}

.advanced-settings-box::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-top: 1px solid #edf2f7;
  border-left: 1px solid #edf2f7;
}

/* جدول مدال راهنما */
.bg-primary {
  background-color: var(--v-primary-base, #1976D2) !important;
}
.settings-icon-box {
  width: 50px;
  height: 50px;
  border: 3px solid #e0e0e0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  background-color: transparent;
}

.settings-icon-box:hover {
  border-color: #bdbdbd;
  background-color: #f5f5f5;
}

/* وقتی تنظیمات باز است */
.settings-icon-box.active-settings {
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  transform: rotate(90deg);
}

/* ------------------- جعبه تنظیمات پیشرفته ------------------- */
.advanced-settings-box {
  background-color: #fcfcfc;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}


</style>
